import { defineMessages } from 'react-intl-next';

export default defineMessages({
    helpCenterReportingPageTitle: {
        defaultMessage: 'Insights',
        description: 'Title message for Help Center Reporting',
        id: 'helpcenter.reporting.title.non-final',
    },
    helpCenterReportingPageSubtitle: {
        defaultMessage:
            'View how Atlassian Intelligence answers are performing in the help center over the last 7 days.',
        description: 'Subtitle message for Help Center Reporting',
        id: 'helpcenter.reporting.subtitle.non-final',
    },
    helpCenterReportingTimeWindow7: {
        defaultMessage: 'Last 7 Days',
        description: 'Time window for showing reports for the last 7 days',
        id: 'helpcenter.reporting.time-window-7.non-final',
    },
    reportingUniqueVisits: {
        defaultMessage: 'Unique users',
        description: 'Title for Unique Visits count metric card',
        id: 'helpcenter.reporting.unique-visits.non-final',
    },
    reportingQuestionsAsked: {
        defaultMessage: 'Usage',
        description: 'Title for Questions Asked metric card',
        id: 'helpcenter.reporting.ques-asked.non-final',
    },
    reportingNoAnswersProvided: {
        defaultMessage: 'Unanswered',
        description: 'Title for No Answers Provided metric card',
        id: 'helpcenter.reporting.no-ans-provided.non-final',
    },
    reportingCSAT: {
        defaultMessage: 'Helpfulness',
        description: 'Title for CSAT score metric card',
        id: 'helpcenter.reporting.csat.non-final',
    },
    helpCenterContentGapTitle: {
        defaultMessage: 'Suggestions to increase helpfulness',
        description: 'Title content gap table for Help Center Reporting',
        id: 'helpcenter.reporting.content-gap.title.non-final',
    },
    helpCenterContentGapSubtitle: {
        defaultMessage:
            'We could not generate answers for these keyword groups in the last 30 days. Add more help resources so users can quickly find the help they need.',
        description: 'Description message for Content Gap Table',
        id: 'helpcenter.reporting.content-gap.description.non-final',
    },
    contentGapKeyword: {
        defaultMessage: 'Keywords',
        description: 'Header for Content Gap Table column for keywords',
        id: 'helpcenter.reporting.content-gap.keyword.non-final',
    },
    contentGapQuestions: {
        defaultMessage: 'Search volume',
        description: 'Header for Content Gap Table column for questions',
        id: 'helpcenter.reporting.content-gap.questions.non-final',
    },
    helpCenterPageLoadFail: {
        defaultMessage: 'Failed to load page',
        description: 'Error message for when the page fails to load',
        id: 'helpcenter.reporting.failure.non-final',
    },
    genericHeading: {
        defaultMessage: 'Something bad happened',
        description: 'Generic error when something could not be loaded',
        id: 'helpcenter.reporting.error-page.generic.error.heading.non-final',
    },
    genericMessage: {
        defaultMessage: 'Looks like we’re having trouble retrieving some information, please refresh the page.',
        description: 'Generic error when something could not be loaded',
        id: 'helpcenter.reporting.error-page.generic.error.message.non-final',
    },
    trendTypeNil: {
        defaultMessage: 'Nil',
        description: 'When trend is exact 0',
        id: 'helpcenter.reporting.trend-type-nil.non-final',
    },
    tooltipUniqueUsers: {
        defaultMessage: 'The total number of unique users who used Atlassian Intelligence answers in the help center',
        description: 'Tooltip for Unique Users metric card',
        id: 'helpcenter.reporting.tooltip.unique-users.non-final',
    },
    tooltipQuestionsAsked: {
        defaultMessage: 'The total number of times Atlassian Intelligence answers were used in the help center',
        description: 'Tooltip for Questions Asked or usage metric card',
        id: 'helpcenter.reporting.tooltip.ques-asked.non-final',
    },
    tooltipCSAT: {
        defaultMessage: 'The percentage of Atlassian Intelligence answers that users marked as helpful',
        description: 'Tooltip for CSAT helpfulness metric card',
        id: 'helpcenter.reporting.tooltip.csat.non-final',
    },
    tooltipNoAnswerProvided: {
        defaultMessage: 'The total number of times Atlassian Intelligence couldn’t generate answers',
        description: 'Tooltip for no answers generated metric card',
        id: 'helpcenter.reporting.tooltip.no-ans.non-final',
    },
    aiConfigNotEnabledError: {
        defaultMessage: 'AI is not enabled for this portal',
        description: 'Error message when AI is not enabled for the tenant',
        id: 'helpcenter.reporting.ai.config.not.enabled.error.non-final',
    },
});
